import Vue from 'vue';
import Router from 'vue-router';

const Login = () => import('./views/Login.vue');
const Callback = () => import('./views/Callback.vue');

Vue.use(Router);

import store from './store';

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Login,
      beforeEnter(to, from, next) {
        store.dispatch('logout');
        next();
      },
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
    {
      path: '*',
      component: Login,
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: () => import('@/views/signUp/SignUp.vue'),
      beforeEnter(to, from, next) {
        store.dispatch('logout');
        next();
      },
    },
    {
      path: '/signUpSuccess',
      name: 'signUpSuccess',
      component: () => import('@/views/signUp/SignUpSuccess.vue'),
      beforeEnter(to, from, next) {
        store.dispatch('logout');
        next();
      },
    },
    {
      path: '/companySetup',
      name: 'companySetup',
      component: () => import('@/views/signUp/CompanySetup.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/economicalValuation/Test.vue'),
    },
    {
      path: '/homePage',
      name: 'homePage',
      component: () => import('@/views/homePage.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Home Page');

          next();
        }
      },
    },

    {
      path: '/ingredientList',
      name: 'ingredientList',
      component: () => import('@/views/rawMaterialMapping/IngredientList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient List');

          next();
        }
      },
    },
    {
      path: '/supplierList',
      name: 'supplierList',
      component: () => import('@/views/rawMaterialMapping/SupplierList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Supplier List');

          next();
        }
      },
    },
    {
      path: '/ingredientDescription',
      name: 'ingredientDescription',
      component: () =>
        import('@/views/rawMaterialMapping/IngredientDescription.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient Description');

          next();
        }
      },
    },
    {
      path: '/batchSpecifications',
      name: 'batchSpecifications',
      component: () =>
        import('@/views/rawMaterialMapping/BatchSpecifications.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Batch Specifications');

          next();
        }
      },
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/views/Support.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Support');

          next();
        }
      },
    },
    {
      path: '/ingredientSpecifications',
      name: 'ingredientSpecifications',
      component: () =>
        import('@/views/rawMaterialMapping/IngredientSpecifications.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient Specifications');

          next();
        }
      },
    },
    {
      path: '/historicalData',
      name: 'historicalData',
      component: () => import('@/views/rawMaterialMapping/HistoricalData.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Historical Data');

          next();
        }
      },
    },
    {
      path: '/economicalValuation',
      name: 'economicalValuation',
      component: () =>
        import('@/views/economicalValuation/EconomicalValuation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Economical Valuation');

          next();
        }
      },
    },
    {
      path: '/evtValuation',
      name: 'evtValuation',
      component: () => import('@/views/economicalValuation/Valuation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Valuation');

          next();
        }
      },
    },
    {
      path: '/evtHistoricalValuations',
      name: 'evtHistoricalValuations',
      component: () =>
        import('@/views/economicalValuation/HistoricalValuations.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Historical Valuations');

          next();
        }
      },
    },
    {
      path: '/evtValuationResult',
      name: 'evtValuationResult',
      component: () =>
        import('@/views/economicalValuation/ValuationResult.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Economical Valuation Result');

          next();
        }
      },
    },
    {
      path: '/evtSimulation',
      name: 'evtSimulation',
      component: () => import('@/views/economicalValuation/Simulation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Economical Valuation Simulation');

          next();
        }
      },
    },
    {
      path: '/evtHistoricalSimulations',
      name: 'evtHistoricalSimulations',
      component: () =>
        import('@/views/economicalValuation/HistoricalSimulations.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch(
            'setHeaderTitle',
            'Economical Valuation Historical Simulation'
          );

          next();
        }
      },
    },
    {
      path: '/evtSimulationResult',
      name: 'evtSimulationResult',
      component: () =>
        import('@/views/economicalValuation/SimulationResult.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'EVT Historical Simulation Results');

          next();
        }
      },
    },
    {
      path: '/feedFormulation',
      name: 'feedFormulation',
      component: () => import('@/views/feedFormulation/FeedFormulation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Feed Formulations');

          next();
        }
      },
    },
    {
      path: '/fftFormulation',
      name: 'fftFormulation',
      component: () => import('@/views/feedFormulation/Formulation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },

    {
      path: '/fft/formulation/SpeciesList',
      name: 'formulationSpeciesList',
      component: () =>
        import('@/views/feedFormulation/newFormulation/SpeciesList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Species List');

          next();
        }
      },
    },
    {
      path: '/fft/formulation/result',
      name: 'formulationResult',
      component: () =>
        import('@/views/feedFormulation/newFormulation/Result.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Formulation Result');

          next();
        }
      },
    },
    {
      path: '/fft/formulation/resultPriceSensitivity',
      name: 'formulationResultPriceSensitivity',
      component: () =>
        import(
          '@/views/feedFormulation/newFormulation/ResultPriceSensitivity.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Price Sensitivity Result');

          next();
        }
      },
    },

    {
      path: '/fftHistoricalFormulations',
      name: 'fftHistoricalFormulations',
      component: () =>
        import('@/views/feedFormulation/archive/HistoricalFormulations.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Historical Formulations');

          next();
        }
      },
    },
    {
      path: '/fftHistoricalPriceSensitivities',
      name: 'fftHistoricalPriceSensitivities',
      component: () =>
        import(
          '@/views/feedFormulation/archive/HistoricalPriceSensitivities.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch(
            'setHeaderTitle',
            'FFT Historical Price Sensitivities'
          );

          next();
        }
      },
    },
    {
      path: '/fftFormulationResult',
      name: 'fftFormulationResult',
      component: () => import('@/views/feedFormulation/FormulationResult.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch(
            'setHeaderTitle',
            'FFT Historical Formulation Results'
          );

          next();
        }
      },
    },
    {
      path: '/fftSimulation',
      name: 'fftSimulation',
      component: () => import('@/views/feedFormulation/Simulation.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/fftHistoricalSimulations',
      name: 'fftHistoricalSimulations',
      component: () =>
        import('@/views/feedFormulation/HistoricalSimulations.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/fft/newFormulationArchive',
      name: 'fftNewFormulationArchive',
      component: () =>
        import('@/views/feedFormulation/archive/newFormulationArchive.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'New Formulation Archive');

          next();
        }
      },
    },
    {
      path: '/fft/priceSensitivityArchive',
      name: 'fftPriceSensitivityArchive',
      component: () =>
        import('@/views/feedFormulation/archive/priceSensitivityArchive.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Price Sensitivity Archive');

          next();
        }
      },
    },
    {
      path: '/fftSimulationResult',
      name: 'fftSimulationResult',
      component: () => import('@/views/feedFormulation/SimulationResult.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/fftReports',
      name: 'fftReports',
      component: () => import('@/views/formulationReport/ReportListView.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
          store.dispatch("setHeaderTitle", "Formulation Reports");
        }
      },
    },
    {
      path: '/fftReport/:id',
      name: 'fftReport',
      component: () => import('@/views/formulationReport/ReportView.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
          store.dispatch("setHeaderTitle", "Formulation Report");
        }
      },
    },
    {
      path: '/companySpecies',
      name: 'companySpecies',
      component: () => import('@/views/companySpecies/CompanySpecies.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Company Species');

          next();
        }
      },
    },

    {
      path: '/companySpecies/nutrSpecs',
      name: 'companySpeciesNutrSpecs',
      component: () => import('@/views/companySpecies/NutrSpecs.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Company Species Nutritional Specs');

          next();
        }
      },
    },
    {
      path: '/fft/pve/countrySelection',
      name: 'pveCountrySelection',
      component: () =>
        import(
          '@/views/feedFormulation/productionVolumeEstimates/CountrySelection.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Production Volume Estimate');

          next();
        }
      },
    },
    {
      path: '/ingredientPrices',
      name: 'ingredientPrices',
      component: () =>
        import(
          '@/views/ingredientPrices/CountrySelection.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient Prices (incl. Historical)');

          next();
        }
      },
    },
    {
      path: '/releaseNotes',
      name: 'releaseNotes',
      component: () => import('@/views/releaseNotes/index.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Release Notes');

          next();
        }
      },
    },
    {
      path: '/ingredientPrices/:countryId',
      name: 'countryIngredientPrices',
      component: () => import('@/views/ingredientPrices/IngredientsPrices.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient Prices (incl. Historical)');
          next();
        }
      },
    },

    {
      path: '/fft/pve/speciesList',
      name: 'pveSpeciesList',
      component: () =>
        import(
          '@/views/feedFormulation/productionVolumeEstimates/SpeciesList.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Production Volume Estimate');

          next();
        }
      },
    },
    {
      path: '/nutritionalSpecs',
      name: 'nutritionalSpecs',
      component: () => import('@/views/NutritionalSpecs.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Nutritional Specs');

          next();
        }
      },
    },
    {
      path: '/recipeList',
      name: 'recipeList',
      component: () => import('@/views/RecipeList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Ingredient List');

          next();
        }
      },
    },
    {
      path: '/FormulationTool',
      name: 'FormulationTool',
      component: () => import('@/views/FormulationTool.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Formulation Tool');
          next();
        }
      },
    },
    {
      path: '/FormulationList',
      name: 'FormulationList',
      component: () => import('@/views/FormulationList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Formulation List');
          next();
        }
      },
    },
    {
     path: '/formulationComparison',
     name: 'formulationComparison',
     component: () => import('@/views/FormulationComparison.vue'),
     beforeEnter(to, from, next) {
       if (!store.getters.isAuthenticated) {
         store.dispatch('logout');
         next('/');
       } else {
         store.dispatch('setHeaderTitle', 'Compare Formulations');

         next();
       }
     },
   },
    {
      path: '/ArchivedFormulations',
      name: 'ArchivedFormulationsList',
      component: () => import('@/views/ArchivedFormulationsList.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Archived Formulations List');
          next();
        }
      },
    },
    {
      path: '/ArchivedFormulations/compare/:id',
      name: 'ArchivedFormulationCompare',
      component: () => import('@/views/ArchivedFormulationItemsCompare.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Compare Archived Formulation');
          next();
        }
      },
    },
    {
      path: '/ArchivedFormulations/:id',
      name: 'ArchivedFormulation',
      component: () => import('@/views/ArchivedFormulationItem.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Archived Formulation');
          next();
        }
      },
    },

    {
      path: '/fft/pve/formulation',
      name: 'pveFormulation',
      component: () =>
        import(
          '@/views/feedFormulation/productionVolumeEstimates/Formulation.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Production Volume Estimate');

          next();
        }
      },
    },
    {
      path: '/fft/pve/formulationCriteria',
      name: 'pveFormulationCriteria',
      component: () =>
        import(
          '@/views/feedFormulation/productionVolumeEstimates/FormulationCriteria.vue'
        ),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'FFT Production Volume Estimate');

          next();
        }
      },
    },
    {
      path: '/management',
      name: 'management',
      component: () => import('@/views/management/Management.vue'),
      beforeEnter(to, from, next) {
        if (!store.getters.isAuthenticated) {
          store.dispatch('logout');
          next('/');
        } else {
          store.dispatch('setHeaderTitle', 'Management');

          next();
        }
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/views/admin/Admin.vue'),
      beforeEnter(to, from, next) {
        if (
          !store.getters.isAuthenticated ||
          store.getters.getUserInfo.role_level < 4
        ) {
          store.dispatch('logout');
          next('/');
        } else {
          next();
        }
      },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let logout = false;
  if (Vue?.$cookies?.get('accessToken') && !store.getters.getAuthResult) {
    store.dispatch('setAuthResult', Vue.$cookies.get('accessToken'));
    store.dispatch('setUserInfo', Vue.$cookies.get('userInfo'));
  }

  //   if (!store.getters.isAuthenticated) {
  //    logout = true;
  //   }
  //  if (logout) {
  //   store.dispatch("logout");
  //   next();
  //  } else {
  next();
});

export default router;
